import type { NavProps } from "@/components/nav";
import { useUser } from "@/core/user/userApplication";
import {
	concatParentPath,
	removeAllButtonChild,
	removeEmptyNode,
	sortTreeByOrder,
	transformMenu2NavRootItem,
	updateMeta,
	transformMenu2BreadcrumbRootItem,
} from "@/utils/menu";
import { pipe } from "ramda";

/**
 * Hook to get filtered navigation data based on user permissions
 * @returns Filtered navigation data
 */
export const useFilteredNavData = (): NavProps["data"] => {
	const { data: user } = useUser();
	return [
		{
			items: pipe(
				sortTreeByOrder,
				removeEmptyNode,
				concatParentPath(""),
				removeAllButtonChild,
				updateMeta,
				transformMenu2NavRootItem,
			)(user?.menus || []),
		},
	];
};

export const useFilteredBreadcrumbData = (): NavProps["data"] => {
	const { data: user } = useUser();
	return [
		{
			items: pipe(
				sortTreeByOrder,
				removeEmptyNode,
				concatParentPath(""),
				removeAllButtonChild,
				updateMeta,
				transformMenu2BreadcrumbRootItem,
			)(user?.menus || []),
		},
	];
};
